import React from "react";
import {
  useDataSourcesDataByIdAutofetch,
  useDataSourcesState,
  useIsDataSourcesStateFetching,
} from "../../../../../store/datasources/useSelectors";
import ListOfDataSources from "./ListOfDataSources";
import { useMappedDataSources } from "../../../../../store/datasources/useActions";

export type ContainerProps = {
  toggled: boolean;
  updateSourcesLength: (newLength: number) => void;
};

const Container = ({ toggled, updateSourcesLength }: ContainerProps) => {
  const dataSourcesData = useDataSourcesDataByIdAutofetch();
  const { mappedDataSources, isLoading } = useMappedDataSources(
    Object.keys(dataSourcesData).map((id) => Number(id)),
    updateSourcesLength
  );
  const dataSourcesState = useDataSourcesState();
  const isDataSourcesStateFetching = useIsDataSourcesStateFetching();

  return (
    <ListOfDataSources
      dataSources={dataSourcesData}
      toggled={toggled}
      mappedDataSources={mappedDataSources}
      dataSourcesState={dataSourcesState}
      isLoading={isDataSourcesStateFetching || isLoading}
    />
  );
};

export default Container;
